import strs from './strings';
import countries from './countries';
import caseTerms from './case';
import curCase from './testCase';
import {uploadFile, deleteFile, getFile } from './googleCloudStorage';
import { FormContext, useAuth } from './context';
import { getFirestoreDoc, getGlobalDocs, getUser, setCase, setFirestoreDoc, setUser } from './firestore';
import { auth } from './firebase';
import { nanoid } from 'nanoid';
import { useContext, useEffect } from 'react';
import * as yup from 'yup';
import { useLocation } from 'react-router-dom';


export function ScrollToTop() {
	useEffect(function () {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, [useLocation().pathname]);

	return null;
}

const caseDocRequirements = {
	auxToResidence: ['fullPassport', 'businessPlan', 'qualification', 'proofOfInvestment', 'tasa790052'],
	studentStay: ['fullPassport', 'proofLegalStatus', 'proofAdmission', 'financialMeans', 'proofInsurance', 'backgroundCheck', 'proofHealth', 'childSchoolEnrollment', 'childCourseCompletion, childSchoolEnrollment', 'childCourseCompletion', 'declarationOfEntry', 'otherEntryDoc'],
	studentStayRenewal: ['fullPassport', 'proofPrevProgramCompletion', 'proofProgramContinuation', 'financialMeans', 'proofInsurance', 'backgroundCheck', 'childSchoolEnrollment', 'childCourseCompletion', 'declarationOfEntry', 'otherEntryDoc'],
	arraigoSocial: ['fullPassport', 'backgroundCheck', 'proofTwoYears', 'fee', 'childSchoolEnrollment', 'childCourseCompletion',],
	arraigoSociolaboral: ['fullPassport', 'backgroundCheck', 'proofTwoYears', 'fee','employmentContract', 'childSchoolEnrollment', 'childCourseCompletion'],
	arraigoSegundaOportunidad: ['fullPassport', 'backgroundCheck', 'proofTwoYears', 'fee','employmentContract', 'childSchoolEnrollment', 'childCourseCompletion'],
	arraigoSocioformativo: ['fullPassport', 'backgroundCheck', 'proofTwoYears', 'fee','employmentContract', 'childSchoolEnrollment', 'childCourseCompletion'],
	arraigoFamiliar: ['fullPassport', 'backgroundCheck', 'proofTwoYears', 'fee','employmentContract', 'childSchoolEnrollment', 'childCourseCompletion'],

	nonLucrativeResidencyRenewal: ['fullPassport', 'backgroundCheck', ,'childSchoolEnrollment', 'childCourseCompletion', 'declarationOfEntry', 'otherEntryDoc'],
	spanishCitizenship: ['fullPassport', 'backgroundCheck', 'declarationOfEntry', 'otherEntryDoc',],
	highSchool: [],
	bachelors: [],
	masters: [],
}

const caseDocOptional = {
	studentStay: ['poa'],
	studentStayRenewal: ['poa', 'backgroundCheck', 'proofHealth'],
	arraigoSocial: [],
	nonLucrativeResidencyRenewal: ['poa'],
	spanishCitizenship: ['poa'],
	highSchool: [],
	bachelors: [],
	masters: [],
}



const caseTypes = [
	"studentStay",
	"studentStayRenewal",
	"arraigoSocial",
	"nonLucrativeResidencyRenewal",
	"spanishCitizenship",
	"highSchool",
	"bachelors",
	"masters",
];

export function containsNumber(str) {
	return /\d/.test(str);
}

export function removeDigits(str) {
	return str.replace(/\d/g, '');
}

export function dateString() {
	const today = new Date();
	const year = today.getFullYear();
	const month = String(today.getMonth() + 1).padStart(2, '0');
	const day = String(today.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
}

//Implementation can be changed if you don't want to use Unix timestamps at any point
function docExpired(doc) {
	const expiry = 86400 * 90;
	const now = Date.now() / 1000;
	const delta = now - doc.uploadTime;
	if (delta > expiry) {
		return true;
	}
	return false;
}

async function getCaseDocs(caseType) {
	const ret = await getGlobalDocs();
	const userDocs = ret.docs;
	console.log('userDocs', userDocs);
	console.log('ret', ret);
	let caseDocs = [];
	for (const doc in userDocs) {
		console.log('doc', doc);
		if (caseDocRequirements[caseType].includes(doc.docType)) {
			console.log('BINGO');
			caseDocs.push(doc);		
		}
	}
	console.log('caseDocs', caseDocs);
	return caseDocs;
}




export async function findExistingDocs(caseType) {
	console.log('findExistingDocs');
	const ret = await getGlobalDocs();
	const userDocs = ret.docs;
	console.log('userDocs', userDocs);
	let prePop = [];
	let docScratch = {}

// 	for (const doc of userDocs) {
	for (let i = userDocs.length - 1 ; i >=0; i--) {
		const doc = userDocs[i]
		console.log('findExistingDocs doc', doc)
		const docType = doc.docType;
		if (caseDocRequirements[caseType].includes(docType) && !docScratch[docType]) {
			console.log(typeof docType)
			docScratch[docType] = doc;
// 			prePop[docType] = doc;
			prePop.push(doc);
		}
	}
	console.log('findExistingDocs prePop', prePop);
	return prePop;
}


export async function docsThatStillExist(docList) {

}

export async function genExistingDocURLs(globalForm, setGlobalForm) {
	console.log('genExistingDocURLs');
	let prePop = globalForm.docs;
	console.log('PREPOP', prePop);
	let caseStatus = globalForm.curStatus;
	const docURLs = {};
	if (!prePop) return docURLs;
	const fetchPromises = prePop.map(async (doc, index) => {
		const blob = await getFile(prePop[index].uuid);
	//if the case is submitted
		if (blob && caseStatus !== "created")
			docURLs[index] = {
// 			docURLs[doc.docType] = {
				url: URL.createObjectURL(blob),
				docType: doc.docType,
				uuid: doc.uuid,
				msg: doc.msg,
			}
		else if (blob) {
			let docType = doc.docType;
// 			if (containsNumber(docType)) docType = removeDigits(docType);
			docURLs[docType] = {
				url: URL.createObjectURL(blob),
				docType: docType,
				uuid: doc.uuid,
				msg: doc?.msg,
			}
		}
		//We never want to remove an item from the list if the case has already been submitted
		else if (globalForm.curStatus === "created"){
			if (index > -1 && index < prePop.length) {
				prePop.splice(index, 1);
			}	
		}
	});

	await Promise.all(fetchPromises);
// 	console.log('allfetch', docURLs)
// 	console.log('prePop after editing', prePop);
	setGlobalForm( prevGlobalForm => ({
		...prevGlobalForm,
		docs: prePop,
	} ) )
	console.log('docURLs', docURLs)
	return docURLs;
}

export function getNumOtherDocs(docList) {
	let numOtherDocs = 0;
	for (let i = 0; i < docList.length; i++) {
		const doc = docList[i];
		const docType = doc?.docType;
		const contains = docType.includes("other");
		if (contains === true) {
			numOtherDocs++;
		}
	}
	return numOtherDocs;
}


export function getCaseID() {
// 	const userDoc = getFirestoreDoc(`/`)
}

export async function checkExistingCases(caseType) {
	const user = await getUser();		
	const caseList = user.caseList ? user.caseList : [];
	const typeExists = caseList.includes(caseType);
	return typeExists;
}

export async function newCase(caseType) {
	const uid = auth.currentUser.uid;
	const user = await getUser();
	
	if (!user.caseList) user['caseList'] = [];

	console.log('USER', user);
	user.caseList.push(caseType);
	setUser(user);

	const caseID = nanoid();
	const caseDocs = await findExistingDocs(caseType); 
	
	let newCaseData = {
		id: caseID,
		caseType: caseType,
		dateOpened: dateString(),
		dateSubmitted: null,
		dateReceived: null,
		dateResolved: null,
		curStatus: "created",
		docs: caseDocs, 
		responseDocs: [],
		notifications: [],
		pendingNotifications: [],
		form: {},
		numChildren: 1, //We want one slot for kid documents. You can still have 'false' kids
		basicInfo: user.basicInfo ? user.basicInfo : {},
		address: user.address? user.address: {},
		responsibleDecs: {},

	}

	if (caseType === 'auxToResidence') {
		newCaseData = {
			...newCaseData,
			auxCompletion: null,	
			licenses: null,
			company: null,
			numJobs: null,
			exColony: null,
		}
	}
	
	console.log('newly created case', newCaseData)
	setFirestoreDoc(`/users/${uid}/cases`, newCaseData, caseID)
	const tmpUser = {
		...user,
		availCases: user?.availCases - 1,
	}
	setUser(tmpUser);
	return newCaseData;
}

export async function availableCases() {
	const user = await getUser();
	const availCases = user?.availCases;
	if (availCases > 0) {
		const tmpUser = {
			...user,
			availCases: availCases - 1,
		}
		setUser(tmpUser);
		return availCases;
	}
	else {
		return 0;
	}
}

export async function caseTypeExists(caseType) {
	const user = await getUser();
	const caseList = user.caseList ? user.caseList : [];
	console.log('caseType exists: casetype:', caseType);
	
	for (const curCase of caseList) {
		console.log('caseType exists: curCase Type', curCase)
		if ( curCase === caseType )
			return true;
	}
		return false;
}

export function formatDate(dateString) {
	if (dateString === null || dateString === '') return '';
	//date should be in YYY-mm-DD format
	const [year, month, day] = dateString.split('-').map(Number);
	const date = new Date(year, month - 1, day);

	const locale = navigator.language || 'en-GB'; // Fallback to 'en-GB' if locale is not available

	const formatter = new Intl.DateTimeFormat(locale, {
		day: '2-digit',
		month: 'long',
		year: 'numeric',
	});

	return formatter.format(date);
}

export async function receiveNotification(thisNotification, curCase) {
	const tmpCase = {...curCase};
// 	const file = `/case-files/notification1.pdf`
// 	const nowISO = new Date().toISOString();
	console.log('receiveNotification tmpCase', tmpCase)
// 	tmpCase.pendingNotifications.map( (notification) => {
// 		if (thisNotification === notification.id) notification.receiving = true;
// 	} )
// 	console.log('tmpCase', tmpCase)

// 	tmpCase.notifications.push(

	//You'd fetch the file and create a url here

// 		{
// 			uuid: nanoid(),
// 			timeReceived: nowISO,
			// url: url,
// 		}
// 	);
	//Important! We have to set the case that we have received the notification
// 	setCase(tmpCase.id, tmpCase);
// 	setCurCase(tmpCase);
// 	console.log('case with new notification', tmpCase);
}


export function formatISODate(isoString) {
    const date = new Date(isoString);

    // Detect the host's current timezone
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const options = {
        year: 'numeric',
        month: 'long',  // Full month name
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
//         second: '2-digit',	//superfluous and takes up space
        timeZone: timezone,  // Use the detected timezone
        timeZoneName: 'long'  // Full timezone name
    };

    const formatter = new Intl.DateTimeFormat('en-US', options);
    return formatter.format(date);
}

export async function validateNewCaseForm(globalForm) {
	const basicInfoSchema = yup.object().shape({
		firstName: yup.string().required(),
		middleName: yup.string(),
		lastName: yup.string().required(),
		secondLastName: yup.string(),
		passportNumber: yup.string().required(),
		NIE: yup.string().required(),
		dateOfBirth: yup.string().required(),
		countryOfBirth: yup.object().required(),
		placeOfBirth: yup.string().required(),
		countriesOfCitizenship: yup.array().required(),
		gender: yup.object().required(),
		fathersFullName: yup.string().required(),
		mothersFullName: yup.string().required(),
		civilStatus: yup.object().required(),
		smallChildren: yup.object().required(),
	});

	const addressSchema = yup.object().shape({
		typeOfStreet: yup.object().required(),
		street: yup.string().required(),
		streetNumber: yup.number().required(),
// 		countryOfResidence: yup.object().required(),
		postalCode: yup.number().required(),
		province: yup.object().required(),
		city: yup.string().required(),
	})

	const docs = globalForm.docs;

	let reqs = {
		absoluteRequirements: {
			fullPassport: false,
			businessPlan: false,
			qualification: false,
			proofOfInvestment: false,
		},
		passportStamp: {
			false: {
				declarationOfEntry: false,
				anotherEntryDoc: false,
			},
			true: null,
		},
		auxCompletion: {
			false: null,
			true: {
				certOfAuxCompletion: false,
			},
		},
		licenses: {
			false: null,
			true: {
				description: false,
			}
		},
		company: {
			false: null,
			true: {
				articlesOfFormation: false,
			}
		},
		exColony: {
			false: {
				tasa: false
			},
			true: {
				docProvingCitizenship: false,	
			}
		},
		children: {
			false: null,
			true: {
				childSchoolEnrollment: false,
				childCourseCompletion: false,

			}
		}
	}

			

	try {
		//These two calls throw errors if they don't validate, so the catch block (waaaay down below) will handle it.
// 		await basicInfoSchema.validate(globalForm.basicInfo, {abortEarly: false})
// 		await addressSchema.validate(globalForm.address, {abortEarly: false})

		//Validate the documents
		for (let key in reqs) {
// 			console.log('key', key);
			if (key === 'absoluteRequirements') {
				for (let i = 0; i < docs.length; i++) {
					const doc = docs[i];
					const docType = doc.docType;
					if (docType in reqs.absoluteRequirements) {
						reqs.absoluteRequirements[docType] = true;
					} 
				}
			}
			else if (key === 'passportStamp') {
				if (globalForm?.passportStamp?.value === true) {
					reqs.passportStamp.true = true;
				}
				else {
					for (let i = 0; i < docs.length; i++) {
						const doc = docs[i];
						const docType = doc.docType;
						if (docType === 'declarationOfEntry' || 'otherEntryDoc') {
							reqs.passportStamp.false[docType] = true;
							break;
						}
					}
				}
			}
			else if (key === 'auxCompletion') {
				if (globalForm?.auxCompletion?.value === false) reqs.auxCompletion.false = true;
				else {
					for (let i = 0; i < docs.length; i++) {
						const doc = docs[i];
						const docType = doc.docType;
						if (docType === 'certOfAuxCompletion') {
							reqs.auxCompletion.true.certOfAuxCompletion = true;
							break;
						}
					}
				}
			}
			else if (key === 'licenses') {
				if (globalForm?.licenses?.value === false) reqs.licenses.false = true;
				else {
					if (globalForm?.typeOfLicenses !== '') reqs.licenses.true.description = true;
				}
			}
			else if (key === 'company') {
				if (globalForm?.company?.value === 'false') reqs.company.false = true;
				else {
					for (let i = 0; i < docs.length; i++) {
						const doc = docs[i];
						const docType = doc.docType;
						if (docType === 'company') {
							reqs.company.true.articlesOfFormation = true;
							break;
						}
					}
				}
			}
			else if (key === 'exColony') {
				console.log('first pass, exColony');
				if (globalForm?.exColony?.value === false) {
					for (let i = 0; i < docs.length; i++) {
						const doc = docs[i];
						const docType = doc.docType;
						console.log('first pass, exColony false')
						console.log('doctype', docType);
						if (docType === 'fee790062') {
							console.log('first pass, fee-790')
							reqs.exColony.false.tasa = true;
							break;
						}
					}
				}
				else {
					for (let i = 0; i < docs.length; i++) {
						console.log('first pass, exColony false')
						const doc = docs[i];
						const docType = doc.docType;
						console.log('doctype', docType);
						if (docType === 'exColony') {
							reqs.exColony.true.docProvingCitizenship = true;
							break;
						}
					}
				}
			}	
			else if (key === 'children') {
				if (globalForm?.basicInfo?.smallChildren?.value === false) reqs.children.false = true;
				else {
					const numChildren = globalForm?.numChildren;
					if (docs.length === 0) {
						continue;
					} 
					else {
						for (let child = 1; child <= numChildren; child++) {
							let docsForCurChild = false;
							for (let i = 0; i < docs.length; i++) {
								const docType = docs[i].docType;
								if (docType === `childSchoolEnrollment${child}`) {
									if (child === numChildren) {
										reqs.children.true.childSchoolEnrollment = true;
									}
									else {
										docsForCurChild = true;
									}
								}
								else if (docType === `childCourseCompletion${child}`) {
									if (child === numChildren) {
										reqs.children.true.childCourseCompletion = true;
									}
									else {
										docsForCurChild = true;
									}
								}
							}
							if (!docsForCurChild) {
								break;
							}
						}
					}
				}
			}
		}

//Now, we walk through reqs and see if it works
		console.log('REQS', reqs);
		let submitFlag = true;
		for (let key in reqs) {
// 			console.log('key', key);
			console.log('submitFlag', submitFlag);
			if (submitFlag === false) break;

			if (key === "absoluteRequirements") {
				console.log('abs requirements block')
				const absoluteRequirements = reqs.absoluteRequirements;
				for (let innerKey in absoluteRequirements) {
					const innerVal = absoluteRequirements[innerKey];
					if (innerVal === false) {
						submitFlag = false;
						break;
					}
				}
			}
			else if (key === 'passportStamp') {
				console.log('passport block');
				const passportStamp = reqs.passportStamp;
				if (passportStamp.true === true) continue;
				let innerFlag = false;
				for (let innerKey in passportStamp.false) {
					const innerVal = passportStamp.false[innerKey]
					if (innerVal === true) {
						console.log('innerFlag true')
						innerFlag = true;
						break;
					}
				}
				submitFlag = innerFlag;
				if (submitFlag === false) {
					console.log('breaking');
					break;
				}
			}
			else if (key === 'auxCompletion') {
				console.log('aux block');
				const auxCompletion = reqs.auxCompletion;
				if (auxCompletion.false === true) continue;
				else if (auxCompletion.true.certOfAuxCompletion === false) submitFlag = false;
			}
			else if (key === 'licenses') {
				console.log('licenses block');
				const licenses = reqs.licenses;
				if (licenses.false === true) continue;
				else if (licenses.true.description === false) submitFlag = false;
			} 
			else if (key === 'company') {
				console.log('company block');
				if (reqs.company.false === true) continue;
				else if (reqs.company.true.articlesOfFormation !== true) submitFlag = false;
			}
			else if (key === 'exColony') {
				console.log('exColony block');
				const exColony = reqs.exColony;
				if (exColony.false.tasa === true) continue;
				else if (exColony.true.docProvingCitizenship === false) submitFlag = false;
			}
			else if (key === 'children') {
				console.log('checkpoint 1')
				const children = reqs.children;
				if (children.false === true) {
					console.log('checkpoint 2');
					continue;
				}
				let innerFlag = false;
				for (let innerKey in children.true) {
					const innerVal = children.true[innerKey];
					if (innerVal === true) {
						innerFlag = true;
						break;
					}
				}
				submitFlag = innerFlag;
			}
		}
		
		if (submitFlag === true) return true;
		return false;
	}
	catch (errors) {
		console.error("Validations errors", errors);
		return false;
	}

}


